export default __webpack_public_path__ + "static/media/gallery25.eaab6824.jpg";